import { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Check if already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isStandalone) return;

    const dismissed = sessionStorage.getItem('pwa_prompt_dismissed');
    if (dismissed) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShowPrompt(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    sessionStorage.setItem('pwa_prompt_dismissed', 'true');
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/40 backdrop-blur-sm" data-testid="pwa-install-prompt">
      <div className="bg-white rounded-t-3xl sm:rounded-3xl p-6 w-full sm:max-w-sm shadow-2xl animate-in slide-in-from-bottom-4">
        <div className="flex items-start justify-between mb-4">
          <div className="w-12 h-12 bg-slate-900 rounded-2xl flex items-center justify-center">
            <Download className="w-6 h-6 text-white" />
          </div>
          <button onClick={handleDismiss} className="text-slate-400 hover:text-slate-600" data-testid="pwa-dismiss">
            <X className="w-5 h-5" />
          </button>
        </div>
        <h3 className="text-lg font-bold text-slate-900 mb-1">Add to Home Screen</h3>
        <p className="text-sm text-slate-500 mb-5">
          Install Memora for quick access and an app-like experience.
        </p>
        <div className="flex gap-3">
          <Button onClick={handleDismiss} variant="outline" className="flex-1 rounded-full" data-testid="pwa-later-btn">
            Maybe Later
          </Button>
          <Button onClick={handleInstall} className="flex-1 bg-slate-900 hover:bg-slate-800 text-white rounded-full" data-testid="pwa-install-btn">
            Install
          </Button>
        </div>
      </div>
    </div>
  );
}
